/**
 * SmartEWM display-label helpers.
 *
 * Business-friendly labels for SAP Systems. The internal identifiers
 * (clientId, clientSapId, code) are NEVER surfaced as labels — they live only
 * in admin detail / preview screens.
 *
 * System label rule (post Multi-Client UX refinement): the SAP System label no
 * longer repeats the Business Client name. The owning client is shown
 * separately, so a system reads simply as "SAP EWM DEV" / "SAP EWM PROD".
 */

/** "SAP EWM DEV" — system type + environment, never the client name. */
export function systemLabel(sys) {
  if (!sys) return "";
  const type = sys.systemTypeLabel
    || (sys.systemModule ? `SAP ${sys.systemModule}` : "SAP");
  const env = sys.environmentLabel || sys.environment || "";
  return `${type} ${env}`.trim();
}

/** Normalised environment code (DEV / QA / UAT / PROD / …) for badge colouring. */
export function envCode(env) {
  return (env || "").trim().toUpperCase();
}
